
/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  console.log('custom.js loaded');

  function isMailClub(title) {
    return title.toLowerCase().includes('mail club');
  }

  function getCart() {
    return fetch('/cart.js').then(r => r.json());
  }

  function showError(btn, message) {
    const existing = document.querySelector('.mail-club-error');
    if (existing) existing.remove();

    const error = document.createElement('p');
    error.className = 'mail-club-error';
    error.style.cssText = 'color: red; margin-top: 10px; font-size: 14px;';
    error.innerText = message;

    if (btn) {
      btn.parentNode.insertBefore(error, btn.nextSibling);
    }

    setTimeout(function() { 
      if (error.parentNode) error.remove(); 
    }, 6000);
  }

  // Intercept the fetch API calls the theme uses for add to cart
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    if (typeof url === 'string' && url.includes('/cart/add')) {
      console.log('cart add intercepted');
      
      return getCart().then(function(cart) {
        const cartItems = cart.items;
        const cartHasMailClub = cartItems.some(i => isMailClub(i.title));
        const cartHasOther = cartItems.some(i => !isMailClub(i.title));

        let newItemTitle = '';
        
        if (options && options.body) {
          const body = options.body;
          let id = null;
          
          if (body instanceof FormData) {
            id = body.get('id');
          } else if (typeof body === 'string') {
            try {
              const parsed = JSON.parse(body);
              id = parsed.id || parsed.items?.[0]?.id;
            } catch(e) {
              const match = body.match(/id=(\d+)/);
              if (match) id = match[1];
            }
          }

          if (id) {
            return fetch('/variants/' + id + '.js')
              .then(r => r.json())
              .then(function(variant) {
                newItemTitle = variant.product_title || '';
                const newIsMailClub = isMailClub(newItemTitle);

                if (newIsMailClub && cartHasOther) {
                  const btn = document.querySelector('[data-add-to-cart]');
                  showError(btn, 'Mail Club items must be purchased separately. Please complete or empty your current cart first.');
                  return Promise.reject(new Error('mail_club_restriction'));
                }

                if (!newIsMailClub && cartHasMailClub) {
                  const btn = document.querySelector('[data-add-to-cart]');
                  showError(btn, 'Mail Club items must be purchased separately. Please complete or empty your current cart first.');
                  return Promise.reject(new Error('mail_club_restriction'));
                }

                return originalFetch(url, options);
              });
          }
        }

        return originalFetch(url, options);
      });
    }

    return originalFetch(url, options);
  };

  // Cart drawer mixed cart warning
  function checkCartForConflicts() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(function(cart) {
        const items = cart.items;
        if (items.length === 0) return;

        const hasMailClub = items.some(i => isMailClub(i.title));
        const hasOther = items.some(i => !isMailClub(i.title));

        const existing = document.querySelector('.mail-club-warning-banner');
        if (existing) existing.remove();

        if (hasMailClub && hasOther) {
          const banner = document.createElement('div');
          banner.className = 'mail-club-warning-banner';
          banner.style.cssText = 'background: #fff3cd; border: 2px solid #e63946; padding: 16px 20px; margin: 20px 0; color: #333; font-size: 15px; line-height: 1.5; position: relative; z-index: 999;';
          banner.innerHTML = '<strong style="display:block; font-size:17px; margin-bottom:8px;">⚠️ Action Required Before Checkout</strong>Your cart contains a Mail Club item mixed with other products. Mail Club must be purchased separately. Please remove either the Mail Club item or your other items before proceeding to checkout.';

          const targets = [
            document.querySelector('[data-items-wrapper]'),
            document.querySelector('[data-items-holder]'),
            document.querySelector('.cart__items__wrapper'),
          ];

          const target = targets.find(t => t !== null);
          if (target) {
            target.parentNode.insertBefore(banner, target);
          }
        }
      });
  }

  document.addEventListener('DOMContentLoaded', checkCartForConflicts);
  document.addEventListener('theme:cart:update', checkCartForConflicts);
  document.addEventListener('theme:cart:added', checkCartForConflicts);

  // Re-run when cart drawer opens
  document.addEventListener('theme:cart:open', checkCartForConflicts);
  document.addEventListener('theme:drawer:open', checkCartForConflicts);

})();